var React = require('react');

function FlagGl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M512 256H0V97.103a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828L512 256z","fill":"#f5f5f5","key":0}),React.createElement("g",{"fill":"#ff4b55","key":1},React.createElement("path",{"d":"M0 256h512v158.897a8.829 8.829 0 01-8.828 8.828H8.828A8.829 8.829 0 010 414.897V256zM176.552 141.241c-63.38 0-114.759 51.38-114.759 114.759H291.31c0-63.379-51.378-114.759-114.758-114.759z"})),React.createElement("path",{"d":"M176.552 370.759c63.38 0 114.759-51.38 114.759-114.759H61.793c0 63.38 51.38 114.759 114.759 114.759z","fill":"#f5f5f5","key":2})]);
}

FlagGl.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagGl;

FlagGl.default = FlagGl;
